import React, { useState } from "react";
import { Helmet } from "react-helmet";
import {
  FiArrowRight,
  FiMail,
  FiMapPin,
  FiMessageSquare,
  FiClock,
  FiCheckCircle,
  FiSend,
  FiPhone,
} from "react-icons/fi";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    interest: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setSubmitted(true);

    setFormData({
      name: "",
      company: "",
      email: "",
      phone: "",
      interest: "",
      message: "",
    });
  };

  const handleNewMessage = () => {
    setSubmitted(false);
  };

  return (
    <>
      <Helmet>
        <title>Contact | Dropgear IO</title>

        <meta
          name="description"
          content="Contact Dropgear IO to discuss AI solutions, intelligent automation, AI agents, and workflow transformation."
        />
      </Helmet>

      <Header />

      <main className="dg-contact-page">

        {/* =====================================================
            HERO
        ===================================================== */}

        <section className="dg-contact-hero">

          <div className="dg-contact-container">

            <div className="dg-contact-hero-content">

              <span className="dg-contact-eyebrow">
                LET'S TALK
              </span>

              <h1>
                Have a workflow
                <span> worth improving?</span>
              </h1>

              <p>
                Tell us what your team is working on. Whether you're exploring
                AI automation, intelligent agents, or a specific operational
                challenge, let's start with the problem and work from there.
              </p>

            </div>

          </div>

        </section>


        {/* =====================================================
            CONTACT SECTION
        ===================================================== */}

        <section className="dg-contact-main">

          <div className="dg-contact-container dg-contact-grid">

            {/* =================================================
                LEFT CONTENT
            ================================================= */}

            <div className="dg-contact-info">

              <span className="dg-contact-eyebrow">
                CONNECT WITH DROPGEAR IO
              </span>

              <h2>
                Let's turn an
                <span> idea into action.</span>
              </h2>

              <p className="dg-contact-info-description">
                Share a little about your business, your workflow, or the
                challenge you're trying to solve. We'll use that context to
                understand where Dropgear IO could fit.
              </p>


              {/* CONTACT DETAILS */}

              <div className="dg-contact-details">

                <a
                  href="mailto:admin@aidropgerio.in"
                  className="dg-contact-detail"
                >

                  <span className="dg-contact-detail-icon">
                    <FiMail />
                  </span>

                  <div>
                    <small>Email</small>
                    <strong>
                      admin@aidropgerio.in
                    </strong>
                  </div>

                </a>

                <a
                  href="tel:+919079768125"
                  className="dg-contact-detail"
                >

                  <span className="dg-contact-detail-icon">
                    <FiPhone />
                  </span>

                  <div>
                    <small>Phone</small>
                    <strong>
                      +91 9079768125
                    </strong>
                  </div>

                </a>


                <div className="dg-contact-detail">

                  <span className="dg-contact-detail-icon">
                    <FiMessageSquare />
                  </span>

                  <div>
                    <small>What we discuss</small>
                    <strong>
                      AI & Automation Opportunities
                    </strong>
                  </div>

                </div>


                <div className="dg-contact-detail">

                  <span className="dg-contact-detail-icon">
                    <FiClock />
                  </span>

                  <div>
                    <small>Business Hours</small>
                    <strong>
                      Monday - Friday : 8:30 AM - 7:00 PM
                    </strong>
                  </div>

                </div>


                <div className="dg-contact-detail">

                  <span className="dg-contact-detail-icon">
                    <FiMapPin />
                  </span>

                  <div>
                    <small>Register Address</small>
                    <strong>
                     T/604, Aarohi Crest Aprt, Nr. arohi Elegance, Bopal, Daskroi, Ahmedabad, Gujrat, India, 380058
                    </strong>
                  </div>

                </div>

              </div>


              {/* CONTACT NOTE */}

              <div className="dg-contact-note">

                <FiCheckCircle />

                <p>
                  No complicated process. Start with a conversation about
                  what you are trying to accomplish.
                </p>

              </div>

            </div>


            {/* =================================================
                FORM
            ================================================= */}

            <div className="dg-contact-form-card">

              {!submitted ? (

                <>
                  <div className="dg-contact-form-heading">

                    <span>
                      START A CONVERSATION
                    </span>

                    <h3>
                      Tell us about your project
                    </h3>

                    <p>
                      Share some details and our team will review your
                      requirements.
                    </p>

                  </div>


                  <form
                    className="dg-contact-form"
                    onSubmit={handleSubmit}
                  >

                    {/* NAME + COMPANY */}

                    <div className="dg-contact-form-row">

                      <div className="dg-contact-field">

                        <label htmlFor="dg-contact-name">
                          Your Name *
                        </label>

                        <input
                          id="dg-contact-name"
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Enter your name"
                          required
                        />

                      </div>


                      <div className="dg-contact-field">

                        <label htmlFor="dg-contact-company">
                          Company
                        </label>

                        <input
                          id="dg-contact-company"
                          type="text"
                          name="company"
                          value={formData.company}
                          onChange={handleChange}
                          placeholder="Company name"
                        />

                      </div>

                    </div>


                    {/* EMAIL + PHONE */}

                    <div className="dg-contact-form-row">

                      <div className="dg-contact-field">

                        <label htmlFor="dg-contact-email">
                          Email Address *
                        </label>

                        <input
                          id="dg-contact-email"
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="you@company.com"
                          required
                        />

                      </div>


                      <div className="dg-contact-field">

                        <label htmlFor="dg-contact-phone">
                          Phone
                        </label>

                        <input
                          id="dg-contact-phone"
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder="+91 00000 00000"
                        />

                      </div>

                    </div>


                    {/* INTEREST */}

                    <div className="dg-contact-field">

                      <label htmlFor="dg-contact-interest">
                        What can we help with? *
                      </label>

                      <select
                        id="dg-contact-interest"
                        name="interest"
                        value={formData.interest}
                        onChange={handleChange}
                        required
                      >

                        <option value="">
                          Select an option
                        </option>

                        <option value="AI Solutions">
                          AI Solutions
                        </option>

                        <option value="AI Automation">
                          AI Automation
                        </option>

                        <option value="AI Agents">
                          AI Agents
                        </option>

                        <option value="Workflow Automation">
                          Workflow Automation
                        </option>

                        <option value="Business Consultation">
                          Business Consultation
                        </option>

                        <option value="Other">
                          Other
                        </option>

                      </select>

                    </div>


                    {/* MESSAGE */}

                    <div className="dg-contact-field">

                      <label htmlFor="dg-contact-message">
                        Tell us more *
                      </label>

                      <textarea
                        id="dg-contact-message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Tell us about your workflow, challenge, or project..."
                        rows="6"
                        required
                      ></textarea>

                    </div>


                    {/* SUBMIT */}

                    <button
                      type="submit"
                      className="dg-contact-submit"
                    >

                      <span>
                        Send Message
                      </span>

                      <FiSend />

                    </button>


                    <p className="dg-contact-form-disclaimer">
                      By submitting this form, you are requesting that
                      Dropgear IO contact you regarding your enquiry.
                    </p>

                  </form>
                </>

              ) : (

                /* =================================================
                   SUCCESS MESSAGE
                ================================================= */

                <div className="dg-contact-success">

                  <div className="dg-contact-success-icon">
                    <FiCheckCircle />
                  </div>

                  <span className="dg-contact-success-label">
                    MESSAGE RECEIVED
                  </span>

                  <h3>
                    Thank you for contacting us!
                  </h3>

                  <p>
                    Your message has been received successfully. Our team
                    will review your enquiry and connect with you shortly.
                  </p>

                  <div className="dg-contact-success-info">

                    <FiClock />

                    <span>
                      We appreciate your interest in Dropgear IO and look
                      forward to speaking with you.
                    </span>

                  </div>

                  <button
                    type="button"
                    className="dg-contact-new-message"
                    onClick={handleNewMessage}
                  >
                    Send another message
                    <FiArrowRight />
                  </button>

                </div>

              )}

            </div>

          </div>

        </section>


        {/* =====================================================
            BOTTOM CTA
        ===================================================== */}

        <section className="dg-contact-bottom">

          <div className="dg-contact-container">

            <div className="dg-contact-bottom-card">

              <div>

                <span className="dg-contact-eyebrow">
                  EXPLORE DROPGEAR IO
                </span>

                <h2>
                  Not sure where
                  <span> to begin?</span>
                </h2>

                <p>
                  Explore our AI solutions, automation capabilities, and
                  industry-focused workflows before starting a conversation.
                </p>

              </div>


              <a
                href="/ai-solutions"
                className="dg-contact-bottom-button"
              >
                Explore AI Solutions
                <FiArrowRight />
              </a>

            </div>

          </div>

        </section>

      </main>

      <Footer />
    </>
  );
};

export default Contact;
